import api from '@/lib/axios';
import { AdverseEventData, ApiResponse } from '@/components/ClinicalAssement/types';

export const adverseEventService = {
  addAdverseEvent: async (data: Partial<AdverseEventData>): Promise<ApiResponse<AdverseEventData>> => {
    const response = await api.post<ApiResponse<AdverseEventData>>('/add_adverse_event', data);
    return response.data;
  },

  updateAdverseEvent: async (caseId: number, data: Partial<AdverseEventData>): Promise<ApiResponse<AdverseEventData>> => {
    const response = await api.post<ApiResponse<AdverseEventData>>(`/add_adverse_events`, data);
    return response.data;
  },

  getAdverseEvent: async (caseId: number): Promise<ApiResponse<AdverseEventData>> => {
    const response = await api.get<ApiResponse<AdverseEventData>>(`/adverse_events/${caseId}`);
    return response.data;
  }
}; 